import { render } from "./FooterService.vue?vue&type=template&id=3060ba50&scoped=true"
import script from "./FooterService.vue?vue&type=script&lang=js"
export * from "./FooterService.vue?vue&type=script&lang=js"

import "./FooterService.vue?vue&type=style&index=0&id=3060ba50&lang=scss&scoped=true"

import exportComponent from "F:\\ds_pc_new\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3060ba50"]])

export default __exports__